import restArguments from './restArguments.js';

// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
export default restArguments(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
});



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/delay.js
// module id = 518
// module chunks = 106